<template>
  <div class="w-100">
    <b-modal id="bv-modal-result" class="px-0" size="xl" hide-footer>
      <v-dialog v-model="dialogSubmit" hide-overlay persistent max-width="290">
        <v-card color="red" dark>
          <v-card-text>
            กำลังประมวลผล
            <v-progress-linear indeterminate color="white" class="mb-0" />
          </v-card-text>
        </v-card>
      </v-dialog>
      <template #modal-title> สรุปรายการ {{ gameMasterName }} </template>
      <div class="d-block text-center">
        <div class="card-body mt-0 px-1 py-0 text-center">
          <h1 class="text-md text-center py-1 my-0 text-primary">
            กรุณาตรวจสอบความถูกต้องก่อนกดยืนยันรายการทุกครั้งเพื่อประโยชน์สูงสุดของท่าน
          </h1>
          <h1
            v-if="gameMasterId == 1"
            class="text-md text-center py-1 my-0 text-primary"
          >
            ** เรทจ่าย ณ ตอนนี้ ยังไม่ถือเป็นที่สิ้นสุด
            กรุณาตรวจสอบความถูกต้องที่รายการโพยอีกครั้ง หลังส่งโพยสำเร็จ **
          </h1>
          <div v-for="acceptant in accepTants" :key="acceptant.slug">
            <div
              v-if="
                _filter(lottoNumbersWithType, ['type', acceptant.slug]).length >
                0
              "
            >
              <h1 class="text-xl bg-yellow text-black text-left py-2 px-2 mb-0">
                {{ acceptant.display }}
              </h1>
              <div class="d-flex text-lg py-1 border-top bg-black text-white">
                <div class="w-20x border-right">
                  <div class="text-center text-lg text-monospace">เลข</div>
                </div>
                <div class="w-20x border-right">
                  <div class="text-center text-lg text-monospace">จำนวน</div>
                </div>
                <div v-if="acceptant.slug == '4upper'" class="w-60x">
                  <div class="text-center text-lg text-monospace">จำนวนชุด</div>
                </div>
                <div
                  v-if="acceptant.slug != '4upper'"
                  class="w-20x border-right"
                >
                  <div class="text-center text-lg text-monospace">จ่าย</div>
                </div>
                <div v-if="acceptant.slug != '4upper'" class="w-40x">
                  <div class="text-center text-lg text-monospace">ชนะ</div>
                </div>
              </div>
            </div>

            <div>
              <bet-recap
                v-for="(lottoNumber, index) in _filter(lottoNumbersWithType, [
                  'type',
                  acceptant.slug,
                ])"
                :key="index"
                class="w-100"
                :item.sync="lottoNumber"
                :master-slug="gameMasterName"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-width mx-1">
          <b-button
            class="mt-3 btn-danger w-100"
            block
            @click="$bvModal.hide('bv-modal-result')"
          >
            ปิด
          </b-button>
        </div>
        <div class="flex-width mx-1">
          <b-button class="mt-3 btn-success w-100" block @click="onConfirm">
            ยืนยัน
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="bv-modal-template" size="xl" hide-footer>
      <template #modal-title> บันทึกรายการ </template>
      <div class="d-block text-center">
        <div class="card-body mt-0 px-1 py-0 text-center">
          <div class="form-group text-left">
            <label for="exampleFormControlInput1 text-left">ชื่อรายการ</label>
            <input
              id="templateName"
              ref="templateName"
              class="form-control"
              name="templateName"
              type="text"
              placeholder="กรอกชื่อรายการ"
              required="required"
              :value="templateName"
              @keyup="updateTemplate($event)"
            />
          </div>
          <div v-for="acceptant in accepTants" :key="acceptant.slug">
            <div
              v-if="
                _filter(lottoNumbersWithType, ['type', acceptant.slug]).length >
                0
              "
            >
              <h1 class="text-xl bg-yellow text-black text-left py-2 px-2 mb-0">
                {{ acceptant.display }}
              </h1>
              <div class="d-flex text-lg py-1 border-top bg-black text-white">
                <div class="w-20x border-right">
                  <div class="text-center text-lg text-monospace">เลข</div>
                </div>
                <div class="w-20x border-right">
                  <div class="text-center text-lg text-monospace">จำนวน</div>
                </div>
                <div class="w-20x border-right">
                  <div class="text-center text-lg text-monospace">เรทจ่าย</div>
                </div>
                <div class="w-40x">
                  <div class="text-center text-lg text-monospace">ชนะ</div>
                </div>
              </div>
            </div>

            <div>
              <bet-recap
                v-for="(lottoNumber, index) in _filter(lottoNumbersWithType, [
                  'type',
                  acceptant.slug,
                ])"
                :key="index"
                class="w-100"
                :item.sync="lottoNumber"
                :master-slug="gameMasterName"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-width mx-1">
          <b-button
            class="mt-3 btn-danger w-100"
            block
            @click="$bvModal.hide('bv-modal-template')"
          >
            ปิด
          </b-button>
        </div>
        <div class="flex-width mx-1">
          <b-button class="mt-3 btn-yellow w-100" block @click="templateSubmit">
            บันทึก
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="bv-modal-get-template" size="xl" hide-footer>
      <v-dialog v-model="dialogSubmit" hide-overlay persistent max-width="290">
        <v-card color="red" dark>
          <v-card-text>
            กำลังประมวลผล
            <v-progress-linear indeterminate color="white" class="mb-0" />
          </v-card-text>
        </v-card>
      </v-dialog>
      <template #modal-title> รายการบันทึกโพย </template>
      <div class="d-block text-center">
        <div class="card-body mt-0 px-1 py-0 text-center">
          <div
            v-for="(list, index) in templateLists"
            :key="list.index"
            class="d-flex border-bottom py-3 justify-content-center align-items-center"
          >
            <div class="flex-width text-left align-items-center">
              {{ list.name }}
            </div>
            <div class="flex-width text-right">
              <button
                class="btn py-2 btn-success"
                @click="selectTemplate(list.numbers)"
              >
                เลือก
              </button>
              <button class="btn py-2 btn-danger" @click="delTemplate(list.id)">
                ลบ
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="text-h6 text-center">
          {{ dialog_message }}
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="(dialog = false), (deldigit = false)"
          >
            ยกเลิก
          </v-btn>

          <v-btn
            color="red darken-1"
            text
            @click="(dialog = false), confirmDelTemplate()"
          >
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="card shadow-sm">
      <div
        class="card-header bg-primary d-flex justify-content-between text-white"
      >
        <span>รายการแทง</span>
        <button
          v-if="
            !gameMasterSlug.startsWith('step_') &&
            !gameMasterSlug.startsWith('big_')
          "
          class="btn btn-xs btn-dark"
          @click="loadTemplate"
        >
          เลขชุด / ดึงโพย
        </button>
      </div>
      <form
        id="betForm"
        method="POST"
        :action="urlApiLottoBet"
        enctype="multipart/form-data"
        @submit.prevent="onSubmit"
      >
        <div id="lottoViewTable" class="card-body px-1 pb-0 text-center">
          <div v-for="acceptant in accepTants" :key="acceptant.slug">
            <h1
              v-if="
                _filter(lottoNumbersWithType, ['type', acceptant.slug]).length >
                0
              "
              class="text-xl bg-black text-white text-left py-2 px-2 mx-1"
            >
              {{ acceptant.display }}
            </h1>
            <div>
              <bet-list
                v-for="(lottoNumber, index) in _filter(lottoNumbersWithType, [
                  'type',
                  acceptant.slug,
                ])"
                :key="index"
                class="w-100"
                :item.sync="lottoNumber"
                :game-master-slug="gameMasterSlug"
                @item-delete="digitClickReview"
                @child-updateBetAmount="updateBetAmount"
              />
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div
            v-if="
              !gameMasterSlug.startsWith('step_') &&
              !gameMasterSlug.startsWith('big_')
            "
            class="d-flex text-md align-items-center"
          >
            <v-text-field
              v-model="priceQuery"
              suffix="฿"
              label="เดิมพันราคาเท่ากันนะ"
              outlined
              onfocus="{ this.value = ''; }"
              type="tel"
              class="w-100 py-0 mt-2"
              @input="isTyping = true"
              @paste="onPaste($event)"
              @keypress="validateNumber($event)"
            />
          </div>
          <div class="form-group d-flex text-lg">
            <div class="flex-width text-left">
              จำนวน {{ lottoNumbersWithType.length }} เลข
            </div>
            <div class="flex-width text-right">
              รวม
              {{
                _sumBy(lottoNumbersWithType, (item) => {
                  return parseInt(item.amount);
                })
              }}
              ฿
            </div>
          </div>
          <div class="form-group d-flex">
            <div class="flex-width">
              <button
                type="button"
                class="btn btn-pink w-100 my-0 text-lg px-2"
                @click="clearDegit"
              >
                ล้าง
              </button>
            </div>
            <div class="flex-width mx-1">
              <button
                type="button"
                class="btn btn-warning w-100 my-0 text-lg px-2"
                @click="templateReview"
              >
                บันทึก
              </button>
            </div>
            <div class="flex-width">
              <button
                type="submit"
                class="btn btn-success w-100 my-0 text-lg px-2"
              >
                ส่งโพย
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import {
  filter as _filter,
  debounce as _debounce,
  sumBy as _sumBy,
  orderBy as _orderBy,
} from "lodash";

export default {
  name: "LottoReview",
  props: {
    urlApiLottoBet: {
      type: String,
      default: "",
    },
    urlApiLottoRate: {
      type: String,
      default: "",
    },
    urlApiLottoTemplate: {
      type: String,
      default: "",
    },
    urlApiGetTemplate: {
      type: String,
      default: "",
    },
    urlApiDelTemplate: {
      type: String,
      default: "",
    },
    lottoNumbersWithType: {
      type: Array,
      required: true,
    },
    accepTants: {
      type: Array,
      required: true,
    },
    gameLimitations: {
      type: Array,
      required: true,
    },
    gameMasterName: {
      default: "",
    },
    gameMasterSlug: {
      default: "",
    },
    gameMasterId: {
      type: Number,
      default: "",
    },
    gameId: {
      type: Number,
      default: "",
    },
  },
  data() {
    return {
      dialogSubmit: false,
      dialog_message: "",
      dialog: false,
      delVal: "",
      specialRate: [],
      gameRound: "",
      countDigit: "",
      countPrice: 0,
      submitticket: true,
      lottoSubmit: [],
      rateKeys: [],
      rateValues: [],
      rateEntries: [],
      templateName: "",
      templateLists: [],
      selectedList: [],
      priceQuery: "",
      isTyping: false,
      isLoading: false,
    };
  },
  watch: {
    priceQuery: _debounce(function () {
      this.isTyping = false;
    }, 500),
    isTyping(value) {
      if (!value) {
        this.changeBetPriceAll(this.priceQuery);
      }
    },
  },
  computed: {
    rePriceAll() {
      this.countPrice = 0;
      for (const element of this.lottoNumbersWithType) {
        this.countPrice += parseInt(element.amount);
      }
    },
  },
  created() {},
  mounted() {
    this.countDigit = this.lottoNumbersWithType.length;
  },
  methods: {
    _sumBy,
    _orderBy,
    _filter,
    _debounce,
    setFocus() {
      this.$refs.templateName.focus();
    },
    validateNumber: (evt) => {
      evt = evt || window.event;

      const charCode = evt.which ? evt.which : evt.keyCode;

      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        if (charCode !== 46) {
          return true;
        }
        evt.preventDefault();
      }
    },
    onPaste(evt) {
      evt.preventDefault();
    },
    updateTemplate(evn) {
      this.$set(this, "templateName", evn.target.value);
    },
    calPayRate(type, digit) {
      const results = this.specialRate.filter(
        (i) => i.digit == digit && i.type == type
      );
      if (results.length > 0) {
        return results[0].pay_baht;
      }
      const results2 = this.accepTantsTemp.filter((sp) => sp.slug == type);
      return results2[0].default_pay_rate;
    },
    selectTemplate(data) {
      this.$set(this, "dialogSubmit", true);
      this.$emit("child-emptyLottoNumbersWithType", 1);
      self = this;
      setTimeout(() => {
        for (let i = 0; i < data.length; i++) {
          self.$emit("child-templateClick", [
            data[i].digits,
            data[i].slug,
            data[i].amount,
          ]);
        }
        self.$bvModal.hide("bv-modal-get-template");
        self.$set(self, "dialogSubmit", false);
      }, 500);
    },
    delTemplate(id) {
      this.$set(this, "delVal", id);
      this.$set(this, "dialog", true);
      this.$set(this, "dialog_message", "ต้องการลบโพยนี้");
    },
    confirmDelTemplate() {
      self = this;
      axios
        .post(this.urlApiDelTemplate, {
          id: this.delVal,
        })
        .then((response) => {
          if (response.status == 200) {
            Vue.$toast.open({
              message: "ลบรายการบันทึกสำเร็จ",
              type: "success",
              duration: 3000,
              position: "top-right",
            });
            self.loadTemplate();
          }
        })
        .catch((error) => {
          if (error.response.status == 406) {
            Vue.$toast.open({
              message: "กรุณาลองใหม่",
              type: "error",
              duration: 5000,
              position: "top-right",
            });
          }
          self.$bvModal.hide("bv-modal-get-template");
        });
    },
    clearDegit() {
      Vue.$toast.open({
        message: "ล้างข้อมูลสำเร็จ",
        type: "error",
        duration: 1000,
        position: "top-right",
      });
      // this.$emit("child-resetLottoNumbersWithType", 1);
      this.$emit("child-emptyLottoNumbersWithType", 1);
    },
    onSubmit(e) {
      const openModal = this.$bvModal.show("bv-modal-result");
    },
    templateReview(e) {
      const openModal = this.$bvModal.show("bv-modal-template");
    },
    templateSubmit() {
      self = this;
      const search = "/";
      const replaceWith = "|";

      const replace = this.templateName.split(search).join(replaceWith);

      if (this.templateName != "") {
        self = this;
        axios
          .post(
            `${this.urlApiLottoTemplate}/${replace}`,
            this.lottoNumbersWithType
          )
          .then((response) => {
            if (response.status == 200) {
              Vue.$toast.open({
                message: "บันทึกโพยเรียบร้อย",
                type: "success",
                duration: 3000,
                position: "top-right",
              });
              self.$bvModal.hide("bv-modal-template");
            }
          })
          .catch((error) => {
            if (error.response.status == 406) {
              Vue.$toast.open({
                message: "เครดิตคงเหลือไม่พอจ่าย",
                type: "error",
                duration: 5000,
                position: "top-right",
              });
            }
          });
      } else {
        Vue.$toast.open({
          message: "ระบุชื่อรายการโพย",
          type: "error",
          duration: 1000,
          position: "top-right",
        });
        this.$nextTick(() => this.setFocus());
      }
    },
    loadTemplate(e) {
      self = this;
      axios
        .get(this.urlApiGetTemplate)
        .then((response) => {
          self.$set(self, "templateLists", response.data);
        })
        .catch((error) => {});
      const openModal = this.$bvModal.show("bv-modal-get-template");
    },
    onConfirm(event) {
      if (this.submitticket) {
        this.$set(this, "submitticket", false);
        this.$set(this, "dialogSubmit", true);

        self = this;
        axios
          .create({
            headers: { "Cache-Control": "no-store" },
          })
          .post(this.urlApiLottoBet, this.lottoNumbersWithType)
          .then((response) => {
            if (response.status == 200) {
              Vue.$toast.open({
                message: "ส่งโพยเรียบร้อย",
                type: "success",
                duration: 3000,
                position: "top-right",
              });
              self.$emit("child-resetLottoNumbersWithType", 1);
              self.$bvModal.hide("bv-modal-result");
            }
          })
          .catch((error) => {
            if (error.response.status == 402) {
              Vue.$toast.open({
                message: "เครดิตคงเหลือไม่พอจ่าย",
                type: "error",
                duration: 3000,
                position: "top-right",
              });
              self.$bvModal.hide("bv-modal-result");
              self.$set(self, "submitticket", true);
            } else if (error.response.status == 401) {
              Vue.$toast.open({
                message: "เกมส์จบ",
                type: "error",
                duration: 3000,
                position: "top-right",
              });
              self.$bvModal.hide("bv-modal-result");
              self.$emit("child-resetLottoNumbersWithType", 1);
            } else if (error.response.status == 406) {
              if (error.response.data.case == "limit") {
                for (let i = 0; i < error.response.data.message.length; i++) {
                  Vue.$toast.open({
                    message: error.response.data.message[i],
                    type: "error",
                    duration: 10000,
                    position: "top-right",
                  });
                }
              } else {
                Vue.$toast.open({
                  message: error.response.data.message,
                  type: "error",
                  duration: 5000,
                  position: "top-right",
                });
              }
              self.$bvModal.hide("bv-modal-result");
              self.$set(self, "submitticket", true);
            } else if (error.response.status == 409) {
              Vue.$toast.open({
                message: "กำลังปรับปรุงเครดิต กรุณาลองอีกครั้ง",
                type: "error",
                duration: 3000,
                position: "top-right",
              });
              self.$bvModal.hide("bv-modal-result");
              self.$set(self, "submitticket", true);
            } else if (error.response.status == 410) {
              Vue.$toast.open({
                message: "ปิดรับแทง",
                type: "error",
                duration: 3000,
                position: "top-right",
              });
              self.$bvModal.hide("bv-modal-result");
              self.$emit("child-resetLottoNumbersWithType", 1);
            } else if (error.response.status == 422) {
              Vue.$toast.open({
                message: "กรุณาเลือกเลข",
                type: "error",
                duration: 3000,
                position: "top-right",
              });
              self.$bvModal.hide("bv-modal-result");
              self.$set(self, "submitticket", true);
            } else if (error.response.status == 429) {
              Vue.$toast.open({
                message:
                  "รายการซ้ำซ้อน ไม่สามารถเลือกเลขโพยและราคาเหมือนกันในเกมส์รอบเดียวกันได้ กรุณาลองใหม่ อีก 30วินาที",
                type: "error",
                duration: 5000,
                position: "top-right",
              });
              self.$bvModal.hide("bv-modal-result");
              self.$set(self, "submitticket", true);
            } else {
              Vue.$toast.open({
                message: "ขัดข้องกรุณาลองใหม่",
                type: "error",
                duration: 3000,
                position: "top-right",
              });
              self.$bvModal.hide("bv-modal-result");
              self.$set(self, "submitticket", true);
            }
            self.$set(self, "dialogSubmit", false);
          });
      }
    },

    digitClickSpecial(val, betType, action) {
      this.$emit("child-digitClickSpecial", val.toString(), betType, action);
    },
    sortArrays(arrays) {
      return _orderBy(arrays, "type", "asc");
    },
    payRate(val, type, index) {
      const obj = this.accepTants.find((o) => o.slug === type);
      return obj.default_pay_rate;
    },
    digitClickReview(data) {
      this.$emit(
        "child-digitClickSpecial",
        data.digits.toString(),
        data.type,
        "splice"
      );
    },
    updateBetAmount(data) {
      this.lottoNumbersWithType[data.index].amount = data.amount;
      this.countPrice = 0;
      for (const element of this.lottoNumbersWithType) {
        this.countPrice += parseInt(element.amount);
      }
    },
    changeBetPriceAll(priceQuery) {
      priceQuery = parseInt(priceQuery);
      this.countPrice = 0;
      const updateAmountAll = this.lottoNumbersWithType.map((item) => {
        const searchIndex = this.gameLimitations.findIndex(
          (limit) => limit.slug == item.type
        );
        item.amount = Math.max(
          1,
          Math.min(this.gameLimitations[searchIndex].maximum, priceQuery)
        );
        this.countPrice += item.amount;
        return item;
      });
      this.$emit("lottoNumbersWithType", updateAmountAll);
    },
    countBetPrice() {},
  },
};
</script>
